import api from '../../api/_article'


const state = () => ({

    all_articles: [],
    all_article: [],
    articles: [],
    article: [],
    deleted: [],
    peremption: [],
    rupture: [],

    liste_articles: [],
    liste_all_articles: [],

    lot_article_ref_id: null
})

// getters
const getters = {
    all_articles: (state) => {
        return state.all_articles;
    },

    liste_articles: (state) => {
        return state.liste_articles;
    },
    liste_all_articles: (state) => {
        return state.liste_all_articles;
    },

    articles: (state) => {
        return state.articles;
    },

    article: (state) => {
        return state.article;
    },

    deleted: (state) => {
        return state.deleted;
    },

    peremption: (state) => {
        return state.peremption;
    },

    rupture: (state) => {
        return state.rupture;
    },

    lot_article_ref_id: (state) => {
        return state.lot_article_ref_id;
    },
};

// mutations
const mutations = {
    SET_ALL_ARTICLES(state, all_articles) {
        state.all_articles = all_articles;
    },
    SET_LISTE_ARTICLES(state, liste) {
        state.liste_articles = liste;
    },
    SET_LISTE_ALL_ARTICLES(state, liste) {
        state.liste_all_articles = liste;
    },
    SET_ARTICLES(state, articles) {
        state.articles = articles;
    },
    SET_ARTICLE(state, article) {
        state.article = article;
    },
    SET_DELETED(state, deleted) {
        state.deleted = deleted;
    },
    SET_RUPTURE(state, rupture) {
        state.rupture = rupture;
    },
    SET_PEREMPTION(state, peremption) {
        state.peremption = peremption;
    },
    SET_LOT_ARTICLE_REF_ID(state, lot_article_ref_id) {
        state.lot_article_ref_id = lot_article_ref_id;
    },
};

// actions
const actions = {
    /**
     * Liste des articles
     */
    getAllArticles({ commit }) {
        return new Promise((resolve, reject) => {
            api.allArticles().then(
                (response) => {
                    commit("SET_ALL_ARTICLES", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    /**
     * Liste des articles
     */
    getListeArticle({ commit }) {
        return new Promise((resolve, reject) => {
            api.getListeArticle().then(
                (response) => {
                    commit("SET_LISTE_ARTICLES", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    /**
     * Liste des articles
     */
    getAllListesArticles({ commit }) {
        return new Promise((resolve, reject) => {
            api.getAllListesArticles().then(
                (response) => {
                    commit("SET_LISTE_ALL_ARTICLES", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    /**
     * Liste des articles
     */
    getArticles({ commit }) {
        api.articles().then((response) => {
            commit("SET_ARTICLES", response);
        });
    },

    /**
     * Enregistre un article
     * @param {*} data
     */
    saveArticle({ commit, dispatch }, data) {
        return api.saveArticle(data).then((response) => {
            if (response.status == 201) {
                commit("SET_ARTICLE", response.data);
                dispatch("getArticles");
                return { response: true, id: response.data.id };
            } else {
                return { response: false };
            }
        });
    },

    /**
     * Modifie un article dont l'id et les données sont passé en paramètres
     * @param {*} id
     * @param {*} data
     */
    async editArticle({ commit, dispatch }, { id, data }) {
        return api.editArticle(id, data).then((response) => {
            commit("SET_ARTICLE", response);
            dispatch("getArticles");
            return true;
        });
    },

    getArticle({ commit }, data) {
        return api.getArticle(data).then((response) => {
            commit("SET_ARTICLE", response);
        });
    },

    deleteArticle({ dispatch }, id) {
        api.deleteArticle(id).then((response) => {
            console.log(response);
            dispatch("getArticles");
            dispatch("getArticleDeleted");
        });
    },

    getArticleDeleted({ commit }) {
        api.deletedArticles().then((response) => {
            commit("SET_DELETED", response);
        });
    },

    getArticleRupture({ commit }) {
        api.rupturesArticles().then((response) => {
            commit("SET_RUPTURE", response);
        });
    },

    getArticlePeremption({ commit }) {
        api.peremptionsArticles().then((response) => {
            commit("SET_PEREMPTION", response);
        });
    },
};



export default {
    state,
    getters,
    actions,
    mutations
}
